export const name = 'rnLocaleFormat';

export default function rnLocaleFormat(rnFormat) {
  'ngInject';

  return rnFormat.toLocaleString;
}



// WEBPACK FOOTER //
// ../~/@printos/rhino/src/components/locale/format/locale-format.filter.js